import React from 'react';

/**
 * Spinner Atom Component
 * A loading spinner component with different sizes and variants
 */
const Spinner = ({ 
  variant = 'primary',
  size = 'md',
  text,
  className = ''
}) => {
  const sizeClass = size === 'sm' ? 'spinner-border-sm' : '';
  const classes = `spinner-border text-${variant} ${sizeClass} ${className}`.trim();

  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className={classes} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      {text && <span className="ms-2">{text}</span>}
    </div>
  );
};

export default Spinner;
